import { ConditionsRating, ConditionsScore, conditionsLabel } from "../../utils/conditions";

interface ConditionsBadgeProps {
    score: ConditionsScore;
    onDark?: boolean;
}

/// The climb rating as a colored word: Prime, Good, Fair, Iffy or Skip
export function ConditionsBadge({ score, onDark = false }: ConditionsBadgeProps) {
    return (
        <span className={`cw-badge cw-badge--${score}` + (onDark ? " cw-badge--on-dark" : "")}>
            {conditionsLabel(score)}
            <span className="cw-sr-only"> climb rating</span>
        </span>
    );
}

interface ConditionsMeterProps {
    rating: ConditionsRating;
    /// Text after the label, e.g. "today"
    suffix?: string;
    onDark?: boolean;
}

/// Label plus a five-segment bar, e.g. "PRIME ▮▮▮▮▮"
export function ConditionsMeter({ rating, suffix, onDark = false }: ConditionsMeterProps) {
    const tone = rating.score >= 4 ? "high" : rating.factors[0] === "wet" || rating.factors[0] === "rain" ? "wet" : "mid";
    return (
        <span className={`cw-meter cw-meter--${tone}` + (onDark ? " cw-meter--on-dark" : "")}>
            <span className="cw-meter__label">
                {rating.label}{suffix && <span className="cw-meter__suffix"> {suffix}</span>}
            </span>
            <span className="cw-meter__bars" aria-hidden="true">
                {[1, 2, 3, 4, 5].map((i) => (
                    <span key={i} className={"cw-meter__bar" + (i <= rating.score ? " cw-meter__bar--on" : "")} />
                ))}
            </span>
            <span className="cw-sr-only">, {rating.score} of 5</span>
        </span>
    );
}
